import styled from "styled-components";
import { Accordion } from "react-bootstrap";
import { } from "../../../constants";

export const AccordionContent = styled(Accordion.Collapse)``;
